export default {
  gutterBottom: {
    marginBottom: 8,
  },
  h5: {
    fontSize: 24,
  },
};
